import React from 'react';
import Grid from '@material-ui/core/Grid';
import { TileWithLink } from '../../components/Tile';
import { RouterConfig } from '../../config/router';
import { StatsContentContainer, StatsTilesContainer } from '../../components/Card';
import { Tooltip } from '../../components/Tooltip';
import { PageWithTitle } from '../../components/PageWithoutTitle';

const pageTitleDraws = [
  {
    title: 'Red Card',
    href: RouterConfig.RedCardStat,
  },
  {
    title: 'No Red Card',
    href: RouterConfig.NoRedCardStat,
  },
];

const DrawHelpText = 'Statytyki związane z remisami';
export default function RedCardPage() {
  return (
    <StatsTilesContainer>
      <PageWithTitle title="Wybór czerwonych kartek" />
      <StatsContentContainer>
        <Grid
          container
          justify="center"
          spacing={2}
          // direction="column"
          alignItems="center"
        >
          {pageTitleDraws.map((item) => (
            <Grid key={item.title} item xs={12}>
              <TileWithLink text={item.title} href={item.href} mobileFull={true} />
            </Grid>
          ))}
        </Grid>
      </StatsContentContainer>
    </StatsTilesContainer>
  );
}
